import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiFlagPipe } from '@taiga-ui/core';
import { TuiPrimitiveTextfieldModule, TuiTextfieldControllerModule, TuiInputModule } from '@taiga-ui/legacy';
import { MaskitoDirective } from '@maskito/angular';

import { FormatPhonePipe } from './pipes';
import { InputPhoneComponent } from './components';

@NgModule({
  declarations: [FormatPhonePipe, InputPhoneComponent],
  imports: [
    CommonModule,
    FormsModule,
    MaskitoDirective,
    TuiFlagPipe,
    TuiInputModule,
    TuiTextfieldControllerModule,
    TuiPrimitiveTextfieldModule,
  ],
  exports: [InputPhoneComponent, FormatPhonePipe],
})
export class PhoneModule {}
